import { API } from './index';
import Cookies from 'js-cookie';

export const createUser = async (
  email: string,
  password: string,
  name: string,
  marketingConsent: boolean
  // captchaToken: any,
) => {
  try {
    const response = await API.post('/api/v1/user/create', {
      email,
      password,
      name,
      role: 0,
      marketingConsent: marketingConsent,
      // captchaToken
    });
    console.log(response.data);
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    throw error.response.data;
  }
};

interface UpdateUserParams {
  email?: string;
  password?: string;
  name?: string;
}

export const updateUser = async ({
  email,
  password,
  name,
}: UpdateUserParams) => {
  const payload: { [key: string]: string | number } = {};

  if (email !== undefined) payload.email = email;
  if (password !== undefined) payload.password = password;
  if (name !== undefined) payload.name = name;

  try {
    const response = await API.put(`/api/v1/user/update`, payload);

    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    throw error.response.data;
  }
};

export const verifyUser = async (email: string, code: string) => {
  try {
    const response = await API.post(`/api/v1/user/verify`, {
      email,
      code,
    });

    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    throw error.response.data;
  }
};

export const getUser = async () => {
  try {
    const response = await API.get(`/api/v1/user/get`);

    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    throw error.response.data;
  }
};

export const getUserById = async () => {
  try {
    const response = await API.get(`/api/v1/user/get-by-id`);

    //console.log(response.data)
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    throw error.response.data;
  }
};

export const resendVerificationToken = async (email: string) => {
  try {
    const response = await API.post(`/api/v1/user/resend-verification-token`, {
      email,
    });

    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    throw error.response.data;
  }
};

export const setOnboardStatus = async () => {
  try {
    const response = await API.put('/api/v1/user/onboarded', {
      onboarded: true,
    });
    return response;
  } catch (error) {
    console.log('Error setting onboard status');
    throw error;
  }
};
